"use client";

import React from "react";
import { Plus, Minus } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const inquiries = [{
  question: "How do I begin planning my custom tour?",
  answer: "Your journey starts with a personal consultation where we explore your interests, pace, and dream destinations. We then craft a bespoke itinerary that balances iconic landmarks with hidden gems only locals know about."
}, {
  question: "What is included in the VOYAGE luxury package?",
  answer: "Our luxury packages are all-encompassing, featuring boutique accommodations, private transportation, curated culinary experiences, and 24/7 concierge support to ensure your exploration is seamless and sophisticated."
}, {
  question: "Can I modify an existing itinerary?",
  answer: "Absolutely. Every tour listed is a foundation that can be fully customized. Whether you want to extend your stay in a specific city or add a specialized activity like a private vineyard tour, we adapt to your desires."
}, {
  question: "What measures are taken for traveler safety?",
  answer: "Safety is our paramount concern. We work exclusively with vetted local partners, provide comprehensive travel insurance options, and maintain real-time communication channels throughout your entire trip."
}];
export default function CommonInquiries() {
  return <section data-section-id="222890" id="common-inquiries" className="bg-background text-foreground py-24 px-6 md:px-12 relative overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(20,20,25,0.03)_0,transparent_100%)] pointer-events-none" />

      <div className="max-w-4xl mx-auto relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-default font-bold tracking-tight mb-4 text-secondary">
            Common Inquiries
          </h2>
          <p className="text-muted-foreground font-default text-lg max-w-2xl mx-auto">
            Everything you need to know about embarking on your next great adventure with VOYAGE.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-4">
          {inquiries.map((inquiry, i) => <AccordionItem key={i} data-index={i} value={`item-${i}`} className="border border-border bg-card px-6 md:px-8 data-[state=open]:bg-accent/50 transition-colors duration-500 rounded-lg shadow-sm">
              <AccordionTrigger className="font-default text-xl md:text-2xl py-6 md:py-8 hover:no-underline [&>svg:last-child]:hidden group">
                <span className="text-left pr-8 font-semibold tracking-wide text-secondary">
                  {inquiry.question}
                </span>
                <div className="relative size-6 shrink-0 flex items-center justify-center text-primary group-hover:text-primary transition-colors duration-300">
                  <Plus className="absolute size-6 transition-all duration-500 group-data-[state=open]:opacity-0 group-data-[state=open]:rotate-90 stroke-[2]" />
                  <Minus className="absolute size-6 transition-all duration-500 opacity-0 -rotate-90 group-data-[state=open]:opacity-100 group-data-[state=open]:rotate-0 stroke-[2]" />
                </div>
              </AccordionTrigger>
              <AccordionContent className="font-serif text-muted-foreground leading-[1.8] text-base md:text-lg pb-8 pt-2 max-w-3xl">
                {inquiry.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}